import type { GeoJSON } from "geojson";

const createGeoItemGeometryTypes = [
  "Point",
  "MultiPoint",
  "LineString",
  "MultiLineString",
  "Polygon",
  "MultiPolygon",
  "GeometryCollection",
  "FeatureCollection",
] as const;

export const isCreateGeoItemGeometry = (geoJson: GeoJSON): boolean =>
  createGeoItemGeometryTypes.some((type) => type === geoJson.type);
